const ALLOWED_COLLECTION_ROUNDS = new Set([
  "routine",
  "fasting",
  "post_prandial",
]);

const normalizeName = (value) => String(value || "").trim().replace(/\s+/g, " ");

const uniqueNames = (values) => {
  const names = [];
  const seen = new Set();
  for (const value of Array.isArray(values) ? values : []) {
    const name = normalizeName(value);
    const key = name.toLowerCase();
    if (!name || seen.has(key)) continue;
    seen.add(key);
    names.push(name);
  }
  return names;
};

const normalizeSingleCollectionRound = (value, fallback = ["routine"]) => {
  const source = Array.isArray(value) && value.length ? value : fallback;
  const round = source
    .map((item) => String(item?.key || item || "").trim().toLowerCase())
    .find((key) => ALLOWED_COLLECTION_ROUNDS.has(key));
  return [round || "routine"];
};

const normalizeCollectionRounds = (assignments) => {
  const rounds = [];
  const seen = new Set();
  for (const assignment of assignments) {
    for (const round of assignment.collectionRounds) {
      if (seen.has(round)) continue;
      seen.add(round);
      rounds.push(round);
    }
  }
  return rounds.length ? rounds : ["routine"];
};

const normalizeFastingHours = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const hours = Number(value);
  return Number.isInteger(hours) && hours >= 1 && hours <= 23 ? hours : null;
};

export const deriveLabPackageMetadata = (testNames, labTestsRows) => {
  const testsByName = new Map(
    (Array.isArray(labTestsRows) ? labTestsRows : [])
      .map((test) => [normalizeName(test?.parameterName).toLowerCase(), test])
      .filter(([name]) => Boolean(name)),
  );
  const missingTests = [];
  const missingFastingHours = [];
  let prescriptionRequired = false;
  let fastingHours = null;

  const collectionRoundAssignments = uniqueNames(testNames).map((testName) => {
    const savedTest = testsByName.get(normalizeName(testName).toLowerCase());
    if (!savedTest) {
      missingTests.push(testName);
      return { testName, collectionRounds: ["routine"] };
    }

    const collectionRounds = normalizeSingleCollectionRound(
      savedTest.collectionRounds,
      savedTest.fastingRequired ? ["fasting"] : ["routine"],
    );
    if (savedTest.prescriptionRequired === true) prescriptionRequired = true;

    if (collectionRounds.includes("fasting")) {
      const testFastingHours = normalizeFastingHours(savedTest.fastingHours);
      if (testFastingHours === null) {
        missingFastingHours.push(testName);
      } else {
        fastingHours = Math.max(fastingHours || 0, testFastingHours);
      }
    }

    return { testName, collectionRounds };
  });

  return {
    collectionRoundAssignments,
    collectionRounds: normalizeCollectionRounds(collectionRoundAssignments),
    prescriptionRequired,
    fastingHours,
    missingTests,
    missingFastingHours,
  };
};
